import React from 'react'
import PropTypes from 'prop-types'

import { getIsVisitorTypeModalOpen, getIsVisitorFormModalOpen } from './utils'
import VisitorTypeModal from './VisitorTypeModal/VisitorTypeModal'
import NewVisitorFormModal from './/NewVisitorFormModal/NewVisitorFormModal'

const ModalsContainer = ({
  newVisitorModalOpen,
  setNewVisitorModalOpen,
  editingVisitor,
  onCloseModal,
  onCreateSuccess,
}) => {
  const isVisitorTypeModalOpen = getIsVisitorTypeModalOpen(newVisitorModalOpen)
  const isVisitorFormModalOpen = getIsVisitorFormModalOpen(newVisitorModalOpen)
  const handleModalChange = (modalType) => {
    setNewVisitorModalOpen(modalType)

    if (!modalType && onCloseModal) {
      onCloseModal()
    }
  }

  return (
    <React.Fragment>
      <VisitorTypeModal
        isOpen={isVisitorTypeModalOpen}
        visitorModalType={newVisitorModalOpen}
        toggleNewVisitorModalType={handleModalChange}
        editingVisitor={editingVisitor}
      />
      <NewVisitorFormModal
        key={`guest-${newVisitorModalOpen}-${editingVisitor?.id || 'new'}`}
        isOpen={isVisitorFormModalOpen}
        visitorModalType={newVisitorModalOpen}
        toggleNewVisitorModalType={handleModalChange}
        editingVisitor={editingVisitor}
        onCreateSuccess={onCreateSuccess}
      />
    </React.Fragment>
  )
}

ModalsContainer.propTypes = {
  newVisitorModalOpen: PropTypes.string,
  setNewVisitorModalOpen: PropTypes.func,
  editingVisitor: PropTypes.object,
  onCloseModal: PropTypes.func,
  onCreateSuccess: PropTypes.func,
}

export default ModalsContainer
